import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthGuard } from './core/services/auth-guard.service';

import { BankPortalAuthService } from './core/services/bankportal-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  public isLoggedIn$: Observable<boolean>;
  constructor (
    public _authService : AuthGuard ,
    private _bankPortalAuthService: BankPortalAuthService,
  ) {
    this.isLoggedIn$ = this._bankPortalAuthService.isLoggedIn$;
    this._bankPortalAuthService.showLoginPageIfTokenExpries();
  }

  ngOnInit() {

  }
}
